/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_DevelopersInputs */

const en_footer_developers = /** @type {(inputs: Footer_DevelopersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Developers`)
};

const zh_hans1_footer_developers = /** @type {(inputs: Footer_DevelopersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开发者`)
};

const pt_br2_footer_developers = /** @type {(inputs: Footer_DevelopersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desenvolvedores`)
};

const es_footer_developers = /** @type {(inputs: Footer_DevelopersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desarrolladores`)
};

const fr_footer_developers = /** @type {(inputs: Footer_DevelopersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Développeurs`)
};

const de_footer_developers = /** @type {(inputs: Footer_DevelopersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entwickler`)
};

const ru_footer_developers = /** @type {(inputs: Footer_DevelopersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разработчикам`)
};

const it_footer_developers = /** @type {(inputs: Footer_DevelopersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sviluppatori`)
};

/**
* | output |
* | --- |
* | "Developers" |
*
* @param {Footer_DevelopersInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_developers = /** @type {((inputs?: Footer_DevelopersInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_DevelopersInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_developers(inputs)
	if (locale === "pt-BR") return pt_br2_footer_developers(inputs)
	if (locale === "es") return es_footer_developers(inputs)
	if (locale === "fr") return fr_footer_developers(inputs)
	if (locale === "de") return de_footer_developers(inputs)
	if (locale === "ru") return ru_footer_developers(inputs)
	if (locale === "it") return it_footer_developers(inputs)
	return en_footer_developers(inputs)
});